import './index.scss';

const ErrorMsg = (props:any) => {
    const { fieldName, error, additionalClass='' } = props;
    return (
        <div id={`${fieldName}_error`} className={`checkout-error-msg ${additionalClass}`} dangerouslySetInnerHTML={{__html: error}}></div>
    )
}
export default ErrorMsg;
